import type { ReactNode } from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface CheckCircleProps {
  className?: string;
  children?: ReactNode;
}

/**
 * Decorative marker circle — check (default) or a number for question lists.
 * Secondary fill matches checklist / objective bullets.
 */
const CheckCircle = ({ className, children }: CheckCircleProps) => (
  <span
    aria-hidden="true"
    className={cn(
      "flex size-7 shrink-0 items-center justify-center rounded-full bg-secondary text-secondary-foreground shadow-sm",
      className
    )}
  >
    {children ?? (
      <Check className="size-4" strokeWidth={3.5} aria-hidden="true" />
    )}
  </span>
);

export default CheckCircle;
